import * as React from 'react';
import { SVGProps } from 'react';

const IconWellPipeSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 11V3H3V1h2v10H4ZM9 1v2H8v8H7V1h2Z" />
  </svg>
);
export default IconWellPipeSizeXs;
